import AssetGroup from '@play-co/timestep-core/lib/ui/resource/AssetGroup';
import { MovieClip } from '@play-co/timestep-core/ui';
import { Pet, PetSpecies } from './replicant/buruburu/pet';
import { Locale } from './replicant/ruleset/locale';
import { TutorialStep } from './replicant/buruburu/tutorial/tutorial.ruleset';
import uiConfig from './lib/ui/config';
import { animationConfig as Match3AnimationConfig } from './game/minigame/match3/components/Match3Block';

// TODO: Ideally use `AssetGroup.PRIORITY_HIGH`.
// timestep-core loader has not yet implemented high priority.

const assets = 'assets';

export const initialAssets = new AssetGroup(
  [
    ...AssetGroup.constructURLs([
      `${assets}/ui/`,
      `${assets}/sounds/sfx`,
      `${assets}/sounds/music/BGM.mp3`,
    ]),
    {
      url: `${assets}/status`,
      loadMethod: MovieClip.animationLoader,
    },
    {
      url: `${assets}/care/firstAid`,
      loadMethod: MovieClip.animationLoader,
    },
    {
      url: `${assets}/care/food`,
      loadMethod: MovieClip.animationLoader,
    },
    {
      url: `${assets}/care/snack`,
      loadMethod: MovieClip.animationLoader,
    },
    {
      url: `${assets}/care/toy`,
      loadMethod: MovieClip.animationLoader,
    },
  ],
  null,
  AssetGroup.PRIORITY_MEDIUM,
);

export const petEvolutionAssets = new AssetGroup([
  {
    url: `${assets}/care/evolve`,
    loadMethod: MovieClip.animationLoader,
  },
]);

export const petSpeciesAssets = Pet.ruleset.species.reduce(
  (acc, species) => ({
    ...acc,
    [species]: new AssetGroup([
      {
        url: `${assets}/species/${species}`,
        loadMethod: MovieClip.animationLoader,
      },
    ]),
  }),
  {} as Record<PetSpecies, AssetGroup>,
);

export const petCrateAssets = new AssetGroup([
  {
    url: `${assets}/tutorial/crate`,
    loadMethod: MovieClip.animationLoader,
  },
]);

export const petTutorialAssets = Object.entries(
  uiConfig.buruburu.tutorial.images,
).reduce(
  (acc, [step, { en }]) => ({
    ...acc,
    [step]: {
      en: new AssetGroup(en),
    },
  }),
  {} as Record<
    Extract<TutorialStep, 'basicGameplay'>,
    Record<Locale, AssetGroup>
  >,
);

export const minigameAssets = new AssetGroup([
  'assets/sounds/sfx/End.mp3',
  'assets/sounds/sfx/Timer.mp3',
  'assets/sounds/sfx/TimerFast.mp3',
]);

export const accessionAssets = new AssetGroup([
  'assets/sounds/sfx/Ascension.mp3',
]);

export const match3Assets = new AssetGroup(
  [
    'assets/minigame/match3/gameboard.png',
    'assets/minigame/match3/ready_en.png',
    'assets/minigame/match3/go_en.png',
    'assets/minigame/match3/finish_en.png',
    ...Object.values(Match3AnimationConfig).map(({ url }) => ({
      url,
      loadMethod: MovieClip.animationLoader,
    })),
  ],
  minigameAssets,
);

export const duoMugAssets = new AssetGroup([
  {
    url: 'assets/care/invitation',
    loadMethod: MovieClip.animationLoader,
  },
]);
